import { use } from 'i18next';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Navigate } from 'react-router-dom';


interface ProtectedRouteProps {
  children?: React.ReactNode;
}

/**
 * A component that protects routes from being accessed by unauthenticated users.
 * 
 * @param {ProtectedRouteProps} props - The properties passed to the component.
 * @param {React.ReactNode} props.children - The child components to render if the user is authenticated.
 * 
 * @returns {JSX.Element} The children components if authenticated, otherwise a <Navigate> component to redirect to the home page.
 */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
 
  const isAuthenticated : boolean  = useSelector((state: any) => state.user?.isAuthenticated);

  return isAuthenticated ? <>{children}</> : <Navigate to="/" />;

}
